import React from 'react';
import styled, { css } from 'styled-components';
import { testId } from '@lojinha/helpers';
import { ChevronLeft, ChevronRight } from '../../../../icons';
import { tabNavigationOutline } from '../../../../helpers/tabNavigationStyle';
import { t } from '../../helpers/dictionary';
const hoverStyle = css `
  ${({ theme }) => `
    border-color: ${theme.colors.success};
    transition: border-color 300ms ease, box-shadow 250ms ease;
    box-shadow: 0px 0px 16px rgba(12, 137, 62, 0.24);

    svg {
      path {
        fill: ${theme.colors.success};
        transition: fill 250ms ease;
      }
    }
  `}
`;
const ButtonStyle = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-around;
  box-shadow: 0px 0px 16px transparent;
  transition: border-color 250ms ease-out, box-shadow 250ms ease;

  svg {
    path {
      transition: fill 200ms ease;
    }
  }

  ${({ theme }) => `
    width: ${theme.space.x32};
    height: ${theme.space.x32};
    border: 2px solid ${theme.colors.gray200};
    border-radius: ${theme.space.x8};
    background-color: ${theme.colors.white};

    ${theme.media.above('md')} {
      width: 100%;
    }
  `}

  ${({ disabled, theme }) => disabled
    ? `
        background-color: ${theme.colors.white};
        border: 1px solid transparent;
        color: ${theme.colors.gray300};
        cursor: not-allowed;
      `
    : ''}
`;
const Container = styled.button `
  cursor: pointer;
  border: 0;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ theme }) => `
    width: ${theme.space.x48};
    padding: ${theme.space.x8};
    min-height: ${theme.space.x48};
    min-width: ${theme.space.x48};
    background-color: ${theme.colors.transparent};

    ${theme.media.above('md')} {
      padding: ${theme.space.x0};
    }
  `}

  &:hover {
    ${ButtonStyle} {
      ${({ disabled }) => (!disabled ? hoverStyle : '')}
    }
  }

  &:focus:not(:focus-visible) {
    ${ButtonStyle} {
      outline: none;
    }
  }

  &:focus-visible {
    ${ButtonStyle} {
      ${tabNavigationOutline}
    }
  }

  ${({ disabled }) => (disabled ? `cursor: not-allowed;` : '')}
`;
export const Button = ({ onClick, dataId, disabled, navigation, children, }) => {
    const { altPrev, altNext } = t.slideArrowsLabel;
    const ARIA_LABEL = navigation === 'prev' ? altPrev : altNext;
    return (React.createElement(Container, { "aria-controls": dataId, "aria-label": ARIA_LABEL, "aria-hidden": disabled, disabled: disabled, onClick: onClick, tabIndex: disabled ? -1 : 0, className: `carousel-arrow carousel-arrow-${navigation}`, ...testId(`carousel-arrow-${navigation}`) },
        React.createElement(ButtonStyle, { disabled: disabled }, !children ? (navigation === 'prev' ? (React.createElement(ChevronLeft, { color: disabled ? 'gray300' : 'black' })) : (React.createElement(ChevronRight, { color: disabled ? 'gray300' : 'black' }))) : (children))));
};
//# sourceMappingURL=index.js.map